"use strict";

var _classCallCheck = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @module seedUtils
 */

var ts_lib_crypto_1 = require("@waves/ts-lib-crypto");

exports.encryptSeed = ts_lib_crypto_1.encryptSeed;
exports.decryptSeed = ts_lib_crypto_1.decryptSeed;

var marshall_1 = require("@waves/marshall");

var Seed = /*#__PURE__*/function () {
  function Seed(phrase, chainId) {
    _classCallCheck(this, Seed);

    if (phrase.length < 12) {
      throw new Error('Your seed length is less than allowed in config');
    }

    this.phrase = phrase;
    this.address = ts_lib_crypto_1.address(phrase, chainId);
    this.keyPair = {
      privateKey: ts_lib_crypto_1.privateKey(phrase),
      publicKey: ts_lib_crypto_1.publicKey(phrase)
    };
    Object.freeze(this);
    Object.freeze(this.keyPair);
  }

  _createClass(Seed, [{
    key: "encrypt",
    value: function encrypt(password, encryptionRounds) {
      return Seed.encryptSeedPhrase(this.phrase, password, encryptionRounds);
    }
  }], [{
    key: "encryptSeedPhrase",
    value: function encryptSeedPhrase(seedPhrase, password) {
      var encryptionRounds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5000;

      if (password && password.length < 8) {// logger.warn('Your password may be too weak');
      }

      if (encryptionRounds < 1000) {// logger.warn('Encryption rounds may be too few');
      }

      if (seedPhrase.length < 12) {
        throw new Error('The seed phrase you are trying to encrypt is too short');
      }

      return ts_lib_crypto_1.encryptSeed(seedPhrase, password, encryptionRounds);
    }
  }, {
    key: "decryptSeedPhrase",
    value: function decryptSeedPhrase(encryptedSeedPhrase, password) {
      var encryptionRounds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5000;
      var wrongPasswordMessage = 'The password is wrong';
      var phrase;

      try {
        phrase = ts_lib_crypto_1.decryptSeed(encryptedSeedPhrase, password, encryptionRounds);
      } catch (e) {
        throw new Error(wrongPasswordMessage);
      }

      if (phrase === '' || phrase.length < 12) {
        throw new Error(wrongPasswordMessage);
      }

      return phrase;
    }
  }, {
    key: "create",
    value: function create() {
      var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 15;
      var phrase = generateNewSeed(words);
      var minimumSeedLength = 12;

      if (phrase.length < minimumSeedLength) {
        // If you see that error you should increase the number of words in the generated seed
        throw new Error("The resulted seed length is less than the minimum length (".concat(minimumSeedLength, ")"));
      }

      return new Seed(phrase);
    }
  }, {
    key: "fromExistingPhrase",
    value: function fromExistingPhrase(phrase) {
      var minimumSeedLength = 12;

      if (phrase.length < minimumSeedLength) {
        // If you see that error you should increase the number of words or set it lower in the config
        throw new Error("The resulted seed length is less than the minimum length (".concat(minimumSeedLength, ")"));
      }

      return new Seed(phrase);
    }
  }]);

  return Seed;
}();

exports.Seed = Seed;

function generateNewSeed() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 15;
  return ts_lib_crypto_1.randomSeed(length);
}

exports.generateNewSeed = generateNewSeed;

function strengthenPassword(password) {
  var rounds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;

  while (rounds--) {
    var bytes = marshall_1.serializePrimitives.STRING(password);
    password = ts_lib_crypto_1.base16Encode(ts_lib_crypto_1.sha256(bytes));
  }

  return password;
}

exports.strengthenPassword = strengthenPassword;